import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { CalendarService } from '../shared/calendar.service';

@Pipe({
  name: 'faDateTime',
})
export class FaDateTimePipe implements PipeTransform {
  constructor(private calendarService: CalendarService) {}

  transform(date: any): string {
    // return this.calendarService.persianDateTime(new Date(timestamp));
    return this.calendarService.persianDateTime(date);
  }
}
